import drugType from '../type/drug';
import quoteGQLString from '../util/quoteGQLString';

export default (orgId) => `
    drugs (org: ${quoteGQLString(orgId)}) {
        ${drugType()}
    }
`;
